<template>
  <!--分包商投标预警-->
  <div>
    <el-group-title class="box-title-margin">
      <template slot="groupTitle">
        <div class="iframe_topbox" v-loading="fullscreenLoading">
          <iframe
            id="tenderWarningIframe"
            width="100%"
            height="500px"
            :src="dataHref"
            frameborder="0"
          ></iframe>
        </div>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "tenderWarning",
  props: {},
  data() {
    return {
      fullscreenLoading: false,
      dataHref: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getLoading();
      let href = "";
      let path = window.location.href;
      if (path.indexOf("uat01") != -1) {
        //uat环境
        href =
          "http://uat01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqrySupBidWarning.cpt&ref_t=design&ref_c=b940ba8b-e160-4e90-8353-bcfe0f2807e3&kj_schemeId=";
      } else if (path.indexOf("test01") != -1) {
        //test环境
        href =
          "http://test01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp_test%252FqrySupBidWarning.cpt&ref_t=design&ref_c=fe4ad318-dd0b-4f92-9395-4911d745455a&kj_schemeId=";
      } else if (path.indexOf("dev01") != -1) {
        //dev环境
        href =
          "http://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqrySupBidWarning.cpt&ref_t=design&ref_c=fe4ad318-dd0b-4f92-9395-4911d745455a&kj_schemeId=";
      } else {
        href =
          "https://fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqrySupBidWarning.cpt&ref_t=design&ref_c=bb6a604f-577d-4d1e-a12a-0ce24dacaae5&kj_schemeId=";
      }
      href =
        href + JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId;
      this.dataHref = href + "&purStep=6";
    },
    getLoading() {
      let _this = this;
      this.fullscreenLoading = true;
      this.$nextTick(() => {
        let biddingIframe = document.getElementById("tenderWarningIframe");
        if (biddingIframe.attachEvent) {
          biddingIframe.attachEvent("onload", function() {
            _this.fullscreenLoading = false;
          });
        } else {
          biddingIframe.onload = function() {
            _this.fullscreenLoading = false;
          };
        }
        setTimeout(function() {
          if (_this.fullscreenLoading) {
            _this.fullscreenLoading = false;
          }
        }, 3000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.alert_maring {
  margin-top: 10px;
}
.iframe_topbox {
  margin: 20px auto;
  /deep/ .el-loading-spinner {
    top: 20vh;
  }
}
.table-three-box-title {
  margin-top: 20px;
  text-align: center;
}
.box-title-margin {
  margin-top: 20px;
}
.btn-box {
  margin-bottom: 20px;
}
</style>
